<template>
  <div id="index">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <nav-bar></nav-bar>
        <el-form
          ref="formselect"
          :model="formselect"
          label-width="100px"
          class="queryform_div"
        >
          <el-row :gutter="24">
            <el-col :md="8" :sm="12" :xs="24">
              <el-form-item :label="$t('desc.roleName')">
                <el-input
                  style="width: 100%"
                  v-model="formselect.queryString"
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="24" :xs="24" style="margin-top: 10px">
              <el-button type="primary" @click="getRoles('search')" size="small">{{
                $t("button.query")
              }}</el-button>
              <el-button @click="formselect.queryString = ''" size="small">{{
                $t("button.reset")
              }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <template>
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="dialogAddRole = true"
            style="margin-bottom: 10px"
            v-show="hasCreateAuth"
            >{{ $t("button.createRole") }}
          </el-button>
          <div class="tableDiv">
            <el-table
              :data="tableData1"
              stripe
              style="width: 100%"
              :empty-text="$t('desc.noData')"
            >
              <el-table-column
                type="index"
                :label="$t('title.serialNumber')"
                width="60px"
                fixed="left"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('desc.roleName')"
                min-width="50px"
              >
              </el-table-column>
              <el-table-column
                prop="displayName"
                :label="$t('desc.description')"
                min-width="50px"
              >
              </el-table-column>
              <el-table-column
                prop="userName"
                :label="$t('desc.userName')"
                min-width="100px"
              >
              </el-table-column>

              <el-table-column
                :label="$t('title.operate')"
                width="200"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    circle
                    class="el-icon-connection"
                    size="mini"
                    :title="$t('dataAuth.DataPermissions')"
                    v-show="hasDataAuth"
                    @click="DataAcces(scope.row)"
                  >
                  </el-button>
                  <el-button
                    type="success"
                    circle
                    class="el-icon-user"
                    size="mini"
                    :title="$t('button.OperatingLicense')"
                    v-show="hasPermissionSetAuth"
                    @click="quanx(scope.row)"
                  >
                  </el-button>
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    :title="$t('button.update')"
                    circle
                    size="mini"
                    v-show="hasUpdateAuth"
                    @click="openEdit(scope.row)"
                  ></el-button>
                  <template>
                    <el-popconfirm
                      placement="top"
                      :confirmButtonText="$t('button.delete')"
                      :cancelButtonText="$t('button.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('title.confirmDelete')"
                      @confirm="deleteRoleInfo(scope.row)"
                    >
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        :title="$t('button.delete')"
                        circle
                        size="mini"
                        slot="reference"
                        v-show="hasDeleteAuth"
                      ></el-button>
                    </el-popconfirm>
                  </template>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="prev, pager, next,sizes"
              :total="pagination.totalPage"
              :current-page.sync="pagination.current"
              :page-size="pagination.pageSize"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              style="text-align: center; margin-top: 10px"
            ></el-pagination>
          </div>
        </template>
      </el-main>
    </el-scrollbar>

    <el-dialog
      :title="$t('button.createRole')"
      :visible.sync="dialogAddRole"
      width="60%"
      top="5vh"
      @close="cancelAdd"
    >
      <el-form ref="roleform" :model="roleform" label-width="150px">
        <el-form-item :label="$t('desc.NO')">
          <el-input
            :disabled="true"
            :placeholder="$t('desc.automaticallyCreation')"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('desc.roleName')"
          prop="name"
          :rules="[
            {
              required: true,
              message: $t('tips.enterRoleName'),
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="roleform.name" style="max-width: 300px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('desc.description')"
          prop="displayName"
          :rules="[
            {
              required: true,
              message: $t('tips.enterRoleDisplay'),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="roleform.displayName"
            style="max-width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('title.serialNumber')"
          prop="orderNum"
          :rules="[
            {
              required: true,
              message: $t('tips.enterOrderNumber'),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="roleform.orderNum"
            type="number"
            style="max-width: 100px"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="数据权限类型" prop="dataPermissionType">
                  <el-select
                    v-model="roleform.dataPermissionType"
                    :placeholder="$t('desc.select')"
                    style="max-width: 300px"
                  >
                    <el-option value="All" :label="$t('desc.all')">全部</el-option>
                    <el-option value="Factory" label="园区">园区</el-option>
                    <el-option value="Laboratory" label="实验室">实验室</el-option>
                    <el-option value="Device" label="设备">设备</el-option>
                  </el-select>
                </el-form-item> -->

        <el-form-item>
          <el-button type="success" @click="addRoleInfo('roleform')">{{
            $t("button.confirm")
          }}</el-button>
          <el-button @click="closeAddialog">{{
            $t("button.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="$t('button.editRole')"
      :visible.sync="dialogEditRole"
      width="60%"
      top="5vh"
      @close="cancelEdit"
    >
      <el-form ref="roleeditform" :model="roleform" label-width="150px">
        <el-form-item :label="$t('desc.NO')">
          <el-input
            v-model="roleform.id"
            :disabled="true"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('desc.roleName')"
          prop="name"
          :rules="[
            {
              required: true,
              message: $t('tips.enterRoleName'),
              trigger: 'blur',
            },
          ]">
          <el-input v-model="roleform.name" style="max-width: 300px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('desc.description')"
          prop="displayName"
          :rules="[
            {
              required: true,
              message: $t('tips.enterRoleDisplay'),
              trigger: 'blur',
            },
          ]">
          <el-input
            v-model="roleform.displayName"
            style="max-width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('title.serialNumber')"
          prop="orderNum"
          :rules="[
            {
              required: true,
              message: $t('tips.enterOrderNumber'),
              trigger: 'blur',
            },
          ]">
          <el-input
            v-model="roleform.orderNum"
            style="max-width: 100px"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="数据权限类型" prop="dataPermissionType">
                  <el-select
                    v-model="roleform.dataPermissionType"
                    :placeholder="$t('desc.select')"
                    style="max-width: 300px"
                  >
                    <el-option value="All" :label="$t('desc.all')">全部</el-option>
                    <el-option value="Factory" label="园区">园区</el-option>
                    <el-option value="Laboratory" label="实验室">实验室</el-option>
                    <el-option value="Device" label="设备">设备</el-option>
                  </el-select>
                </el-form-item> -->

        <el-form-item>
          <el-button type="success" @click="editRoleInfo('roleeditform')"
            >{{ $t("button.confirm") }}
          </el-button>
          <el-button @click="closeEditDialog">{{
            $t("button.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="$t('button.OperatingLicense')"
      :visible.sync="dialogEditPermission"
      width="60%"
      top="5vh"
    >
      <el-form
        ref="formPer"
        :model="formPer"
        label-position="left"
        label-width="150px"
        id="formPer"
      >
        <el-form-item :label="$t('desc.page')">
          <el-form-item :label="$t('desc.childPage')">
            <span>{{ $t("desc.permissions") }}</span>
          </el-form-item>
        </el-form-item>
        <div v-for="(item, index) in MenuData" :key="index">
          <el-form-item :label="$t('menu.'+item.code)">
            <div v-if="item.children.length > 0">
              <div v-for="childitem in item.children" :key="childitem.id">
                <el-form-item :label="$t('menu.'+childitem.code)">
                  <el-checkbox-group v-model="operationsChoosed">
                    <el-checkbox
                      v-for="opt in childitem.operations"
                      :key="opt.code"
                      :label="opt.code"
                    >
                      {{ opt.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
            </div>
            <div v-else>
              <el-form-item :label="$t('desc.none')">
                <!--                                <el-checkbox-group v-model="item.code">-->
                <!--                                    <el-checkbox label="查看" name="code"></el-checkbox>-->
                <!--                                </el-checkbox-group>-->
                <div v-for="childitem in item.operations" :key="childitem.id">
                  <el-form-item>
                    <el-checkbox-group v-model="operationsChoosed">
                      <el-checkbox
                        :key="childitem.code"
                        :label="childitem.code"
                      >
                        {{ childitem.label }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </div>
              </el-form-item>
            </div>
          </el-form-item>
        </div>

        <el-form-item class="noborder">
          <el-button type="success" @click="onSubmit">{{
            $t("button.confirm")
          }}</el-button>
          <el-button @click="dialogEditPermission = false">{{
            $t("button.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 数据权限设置 -->
    <el-dialog
      :title="$t('dataAuth.PermissionSetting')"
      :visible.sync="dialogEditDataAccess"
      width="60%"
      top="5vh"
    >
      <el-form ref="formDataAcces" :model="formDataAcces" label-width="150px">
        <el-form-item :label="$t('desc.roleName')">
          <el-input
            v-model="formDataAcces.name"
            :disabled="true"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('desc.description')">
          <el-input
            v-model="formDataAcces.displayName"
            :disabled="true"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('title.brand')">
          <el-select 
            multiple
            @change="changeBrand"
            v-model="formDataAcces.brandRange" 
            :placeholder="$t('desc.select')">
            <el-option
              v-for="item in BrandOptions"
              :key="item.brandCode"
              :label="item.brandName"
              :value="item.brandCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('title.productLine')">
          <el-select 
            multiple
            v-model="formDataAcces.productLineRange" 
            :placeholder="$t('desc.select')">
            <el-option
              v-for="item in productLineArr"
              :key="item.bnDictCode"
              :label="item.bnDictName"
              :value="item.bnDictCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('title.customerCenter')">
          <el-cascader
            v-model="formDataAcces.regionRange"
            :options="AreaOptions"
            :props="{ multiple: true, checkStrictly: true }"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('title.time')">
          <el-radio-group
            @change="changeTimeType"
            v-model="formDataAcces.timeType"
            style="padding-top: 8px; vertical-align: top; display: flex"
          >
            <el-radio label="none">{{$t('dataAuth.NoRestrictions')}}</el-radio>
            <el-radio label="afterSwitch"
              >{{$t('dataAuth.SwitchingTime')}}
              <div
                v-if="formDataAcces.timeType == 'afterSwitch'"
                class="DataAccesTimeDiv"
              >
                <el-radio-group v-model="formDataAcces.timeRange">
                  <el-radio label="register_all">{{$t('desc.all')}}</el-radio>
                  <el-radio label="register_range1">{{$t('dataAuth.LastMonth')}}</el-radio>
                  <el-radio label="register_range2">{{$t('dataAuth.LastThreeMonths')}}</el-radio>
                  <el-radio label="register_range3">{{$t('dataAuth.LastSixMonths')}}</el-radio>
                  <el-radio label="register_range4">{{$t('dataAuth.LastYear')}}</el-radio>
                </el-radio-group>
              </div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="noborder">
          <el-button @click="updateDataAuth" type="success">{{ $t("button.confirm") }}</el-button>
          <el-button @click="dialogEditDataAccess = false">
            {{ $t("button.cancel") }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRoles,
  RolePermissionSet,
  addRoles,
  updateRoles,
  deleteRole,
  getAllRoles,
  GetAllMenus,
  authOperationCheck,
  GetUserMenu,
  getDataAuthByRole,
  getBrandInfos,
  getBrandInfosNoAcess,
  updateDataAuth,
  getCustomerRegionTree,
  authenticate,
  getAllCustomerRegionTree,
  getProductLines
} from "../../api/api";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import {
  setItemToLocalstorage,
  delItemFormLocalstorage,
} from "../../../utils/package-localstorage";

export default {
  name: "Index",

  mounted() {
    this.getRoles();
    this.getDataList();
    this.getBrandInfos();
    this.getCustomerRegionTree();
    this.getProductLines();
  },

  data() {
    return {
      dialogAddRole: false,
      dialogEditRole: false,
      dialogEditPermission: false,
      dialogEditDataAccess: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      hasPermissionSetAuth: false,
      hasDataAuth: false,
      tableData1: [],
      MenuData: [],
      operationsChoosed: [],
      formselect: {
        queryString: "",
      },
      roleform: {
        id: "",
        name: "",
        orderNum: "",
        displayName: "",
        permissions: [],
        dataPermissionType: "",
      },
      props: { multiple: true },
      optionsinfo: [],
      formPer: {},
      checkboxData: [],
      activeId: "",
      //分页
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      FormHeight: {
        height: "",
        overflow: "auto",
        marginRight: "-10px",
        marginTop: "-10px",
        marginBottom: "-10px",
        padding: "10px",
      },
      formDataAcces: {
        name:"",
        displayName:"",
        brandRange:"",
        regionRange:"",
        timeRange:""
      },
      BrandOptions: [],
      AreaOptions: [],
      AllAreaOptions: [],
      checkList: [],
      productLineArr:[]
    };
  },
  created: function () {
    this.authOperation("Role");
  },
  // computed:mapState({
  //   isCollapse:state=>state.isCollapse
  // }),
  methods: {
    ...mapMutations([
      "setLanguage",
      "setMenuListState",
      "setAuthOperationState",
    ]),
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasPermissionSetAuth = res.hasPermissionSetAuth;
      that.hasDataAuth=res.hasDataAuth;
    },
    async getProductLines(){
      let that=this;
      let res = await getProductLines();
      that.productLineArr = res.result;
      this.$set(this.formselect, "productLine", "Other")
    },
    async getRoles(type) {
      if (type == "search") {
        this.pagination.current = 1;
      }
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize; //开始条
      let data = await getRoles(
        this.formselect.queryString,
        skipcount,
        this.pagination.pageSize
      );
      this.pagination.totalPage = data.result.totalCount;
      this.tableData1 = data.result.items;
      for (let index = 0; index < data.result.items.length; index++) {
        this.tableData1[index].userName = "";
        for (let j = 0; j < data.result.items[index].userList.length; j++) {
          this.tableData1[index].userName +=
            data.result.items[index].userList[j] + ",";
        }
        this.tableData1[index].userName = this.tableData1[
          index
        ].userName.substring(0, this.tableData1[index].userName.length - 1);
      }
    },
    async addRoleInfo(formName) {
      try {
        let that= this;
        let isValid = true;
        that.$refs[formName].validate((valid) => {
        if (!valid) {
          isValid =false;
          }
        })
        if (!isValid){
          return false;
        }
        this.roleform.displayName = this.roleform.displayName;
        this.roleform.sort = this.roleform.orderNum;
        delete this.roleform.id;
        const data = await addRoles(this.roleform);
        this.dialogAddRole = false;
        this.roleform = {
          id: "",
          name: "",
          orderNum: "",
          displayName: "",
          permissions: [],
          dataPermissionType: "",
        };
        if (data.success === true) {
          this.$message({
            message: this.$t('tips.createSuccess'),
            type: "success",
          });
          this.getRoles();
        }
      } catch (e) {
        this.dialogAddRole = false;
        let msg = e.error.message;
        if (e.error.validationErrors[0].message){
          msg = e.error.validationErrors[0].message;
        }
        this.$message.error(msg);
      }
      
    },

    cancelAdd() {
      this.roleform = {
        id: "",
        name: "",
        orderNum: "",
        displayName: "",
        permissions: [],
        dataPermissionType: "",
      };
    },

    cancelEdit() {
      this.roleform = {
        id: "",
        name: "",
        orderNum: "",
        displayName: "",
        permissions: [],
        dataPermissionType: "",
      };
    },

    async editRoleInfo(formName) {
      try {
        let that= this;
        let isValid = true;
        that.$refs[formName].validate((valid) => {
        if (!valid) {
          isValid =false;
          }
        })
        if (!isValid){
          return false;
        }
        this.roleform.displayName = this.roleform.displayName;
        this.roleform.sort = this.roleform.orderNum;
        const data = await updateRoles(this.roleform);
        this.dialogEditRole = false;
        this.roleform = {
          id: "",
          name: "",
          orderNum: "",
          displayName: "",
          permissions: [],
          dataPermissionType: "",
        };
        if (data.success === true) {
          this.$message({
            message: this.$t("tips.updateSuccess"),
            type: "success",
          });
          this.getRoles();
        }
      } catch (e) {
        this.dialogAddRole = false;
        let msg = e.error.message;
        if (e.error.validationErrors[0].message){
          msg = e.error.validationErrors[0].message;
        }
        this.$message.error(msg);
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
        }
      });
    },
    quanx(row) {
      var that = this;
      this.roleform.permissions = JSON.parse(JSON.stringify(row)).permissions;
      this.activeId = JSON.parse(JSON.stringify(row)).id;
      this.dialogEditPermission = true;
      this.operationsChoosed = that.roleform.permissions;
      this.FormHeight.height = window.innerHeight - 180 + "px";
    },
    async DataAcces(row) {
      var that = this;
      this.dialogEditDataAccess = true;
      this.formDataAcces = JSON.parse(JSON.stringify(row));
      await this.getDataAuthByRole(row);
      this.FormHeight.height = window.innerHeight - 180 + "px";
      this.changeBrand();
      // this.changeProductD();
    },
    async getDataAuthByRole(row){
      let that=this;
      console.log(row);
      let res = await getDataAuthByRole(row.id);
      for (let key in res.result) {
        if (key != "id") {
          this.$set(this.formDataAcces, key, res.result[key])
        }
      }
      if(!this.formDataAcces.timeRange || this.formDataAcces.timeRange == "all"){
        this.$set(this.formDataAcces,"timeType","none");
      }else{
        this.$set(this.formDataAcces,"timeType","afterSwitch");
      }
    },
    async updateDataAuth(){
      let that=this;
      try {
        if (this.formDataAcces.timeType != 'afterSwitch') {
          this.$set(this.formDataAcces,"timeRange","all");
        }
        console.log(this.formDataAcces);
        await updateDataAuth(this.formDataAcces);
        that.$message({
          showClose: true,
          message: that.$t("tips.updateSuccess"),
          type: "success"
        });
        this.dialogEditDataAccess = false;
        this.formDataAcces = new Object();
      } catch (error) {
        if (error != undefined) {
          that.$message({
            showClose: true,
            message: error.error.message,
            type: "error"
          });
        }
      }
    },
    async getBrandInfos(){
      let that=this;
      let res = await getBrandInfosNoAcess();
      that.BrandOptions = res.result;
      
    },
    async getCustomerRegionTree() {
      let that = this;
      let res = await getAllCustomerRegionTree();
      that.AreaOptions=res.result;
      this.AllAreaOptions = res.result;
    },
    async openEdit(row) {
      var that = this;
      this.roleform = JSON.parse(JSON.stringify(row));
      // this.roleform.orderNum = this.roleform.orderNum
      this.dialogEditRole = true;
    },
    async deleteRoleInfo(row) {
      const data = await deleteRole(parseInt(row.id));
      if (data.success === true) {
        this.$message({
          message: this.$t("tips.deleteSuccess"),
          type: "success",
        });
        this.getRoles();
      }
    },

    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getRoles();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getRoles();
    },
    async closeAddialog() {
      this.dialogAddRole = false;
      this.roleform = {
        id: "",
        name: "",
        orderNum: "",
        displayName: "",
        permissions: [],
        dataPermissionType: "",
      };
    },
    async closeEditDialog() {
      this.dialogEditRole = false;
      this.roleform = {
        id: "",
        name: "",
        orderNum: "",
        displayName: "",
        permissions: [],
        dataPermissionType: "",
      };
    },
    //操作授权
    getDataList() {
      let that = this;
      GetAllMenus().then((res) => {
        let data = res.result;
        data = JSON.stringify(data).replace(/name/g, "label");
        that.MenuData = JSON.parse(data);
      });
    },

    handleChange() {
      this.checkEquipArr = [];
      let arr = this.checkedEquipments;
      for (let i = 0; i < arr.length; i++) {
        let equipment = arr[i];
        if (equipment.length > 0) {
          let obj = {
            id: this.equipments[i].id,
            equips: [],
          };
          for (let j = 0; j < equipment.length; j++) {
            obj.equips.push(equipment[j]);
          }
          this.checkEquipArr.push(obj);
        }
      }
    },
    openNotice() {
      this.$notify({
        title: "警告",
        message: "这是一条警告的提示消息",
        type: "warning",
      });
    },

    handleAccredit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    onSubmit() {
      console.log(this.operationsChoosed, this.activeId);
      var that = this,
        data = {
          id: this.activeId,
          permissions: this.operationsChoosed,
        };
      this.dialogEditPermission = false;
      RolePermissionSet(data).then(
        (res) => {
          if (res.success) {
            that.getRoles();
            that.$message({
              message: that.$t("tips.saveSuccess"),
              type: "success",
            });
            that.getUserMenu();
          } else {
            that.$message({
              message: that.$t("tips.saveFailed"),
              type: "error",
            });
          }
        },
        (err) => {
          that.$meassage.error(err.error.message);
        }
      );
    },
    async getUserMenu() {
      var that = this;
      await GetUserMenu()
        .then(
          (res) => {
            if (res.success === true) {
              var menuList = res.result;
              if (menuList == null || menuList.length == 0) {
                isEmptyMenu = true;
              } else {
                //缓存用户操作权限
                var authOperations = [];
                menuList.forEach(function (obj, index) {
                  obj.operations.forEach((op1) => {
                    authOperations.push(op1);
                  });
                  if (obj.children.length > 0) {
                    obj.children.forEach(function (o, i) {
                      o.operations.forEach((op2) => {
                        authOperations.push(op2);
                      });
                    });
                  }
                });
                that.setMenuListState(menuList);
                that.setAuthOperationState(authOperations);

                delItemFormLocalstorage("menuData");
                delItemFormLocalstorage("authOperations");

                menuList = menuList.filter(a=>a.code != "MultiBrand_View" && a.code != "EmcStationMonitorScreen_View")
                setItemToLocalstorage("menuData", menuList);
                setItemToLocalstorage("authOperations", authOperations);
              }
            } else {
              that.$message({
                showClose: true,
                message: "error",
                type: "error",
              });
            }
          },
          (err) => {
            if (err.error.code != 401) {
              that.$message.error(err.error.message);
            }
          }
        )
        .catch((err) => {
          if (err.error.code != 401) {
            that.$message.error(err.error.message);
          }
        });
    },
    changeTimeType(val) {
      let that = this;
    },
    changeBrand(){
      this.AreaOptions=this.AllAreaOptions.filter(x=>this.formDataAcces.brandRange.some(a=>x.brand == a));
    },
    changeProductD(){
      this.AreaOptions = JSON.parse(JSON.stringify(this.AllAreaOptions))
      this.AreaOptions.forEach(x=> {
        x.children = x.children.filter(y=>this.formDataAcces.productLineRange.some(a=>y.value.indexOf(a)>-1))
      });
    }
  },

  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
};
</script>

<style scoped>
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #828393;
  padding-left: 10px;
}

#formPer > div {
  margin-bottom: 0px;
  border-bottom: 1px solid #828393;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
#formPer .el-form-item {
  margin-bottom: 5px;
  margin-top: 5px;
}
#formPer .el-checkbox-group {
  line-height: 16px;
  margin-top: 6px;
}
#formPer .el-checkbox {
  min-width: 80px;
}
</style>
